import { Navigate, useParams } from 'react-router';

const AWAPreStartRedirect = () => {
  const { workspaceId, assetId } = useParams();

  return <Navigate to={`/${workspaceId}/inspection${assetId ? `/${assetId}` : ''}`} replace />;
};

export default AWAPreStartRedirect;
